// luckily we'll create custom resource feature before we have to expand this
export const PARKING_IS_A_LOCKER: string[] = [
  "americandentalassociation" // American Dental Association
  // 'gondor'
] as const;

export const getCustomParkingVerbiage = (slug: string) => {
  return shouldUseCustomParkingVerbiage(slug) ? "locker" : null;
};

export const shouldUseCustomParkingVerbiage = (slug: string) => {
  return PARKING_IS_A_LOCKER.includes(slug);
};
